import React from "react";
import { useFlag } from '@innovid/feature-flags-react';
import { FEATURE_FLAGS } from 'featureFlag/featureFlag';
import { TextOverflow, safeDecodeURIComponent } from "utils/common";
import { buildBulkSharableLink, buildSharableLink } from "widgets/modals/creatives/preview/sharing/utils";

export default function LinkTable(props){
	const forceNewPreview = useFlag(FEATURE_FLAGS.NEW_PREVIEW_LINKS);
	const {
		links = [],
		useVersionLinks,
	} = props;
	const rows = links.map((link) => {
		const adType = link.creative?.adType;
		const url = adType ? buildSharableLink(link.publicId, link.creative, useVersionLinks, forceNewPreview) : buildBulkSharableLink(link.publicId, links, useVersionLinks, forceNewPreview);
		return (
			<tr key={link.publicId}>
				<td className="name-col">
					<TextOverflow value={safeDecodeURIComponent(link.previewName)} />
				</td>
				<td className="link-col">
					<a href={url} target="_blank">
						<TextOverflow value={url} />
					</a>
				</td>
			</tr>
		);
	});

	return (
		<table className="basic-table">
			<thead>
				<tr>
					<th className="name-col">Name</th>
					<th className="link-col">URL</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

LinkTable.displayName = "LinkTable";
LinkTable.defaultProps = {
	links: [],
	useVersionLinks: false,
};
